import React from 'react';
import IndustryPageTemplate from './IndustryPageTemplate';
import image from '../../../assets/ChatGPT Image Aug 24, 2026, 01_49_52 PM.png';

const LiveIndustry = () => {
  return (
    <IndustryPageTemplate
      title="Live"
      subtitle="Engage Your Audience in Real-Time"
      desc="Go live, engage your audience and stream your content in real-time. Broadcast events, connect instantly, and build a massive following through interactive streaming."
      image={image}
      themeColor="#e91e63"
      bgGradient="linear-gradient(135deg, rgba(233,30,99,0.15), rgba(255,255,255,0))"
      features={[
  {
    "title": "Live Streaming",
    "desc": "Broadcast in ultra-high definition with zero latency across the globe."
  },
  {
    "title": "Viewer Interaction",
    "desc": "Engage with your fans using live Q&A, polls, and interactive elements."
  },
  {
    "title": "Live Chat & Reactions",
    "desc": "Build community with real-time chat moderation and expressive reactions."
  },
  {
    "title": "Multi-platform Streaming",
    "desc": "Simulcast your live feed to YouTube, Twitch, and custom RTMP servers."
  }
]}
    />
  );
};

export default LiveIndustry;
